import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledSectionFAQ = styled(Styled.Section)`
position: relative;
z-index:2;
overflow:hidden;
@media screen and (max-width: 999px) {
    padding-top:138px;
}
`

export const Styledtext = styled(Styled.PBody1)`
margin-top:16px;
margin-bottom:24px;
`
export const StyledTitle = styled(Styled.H2)`
hyphens: auto;
word-wrap: break-word;
@media screen and (max-width: 999px) {
    display:none;
}
`

export const StyledTitleMob = styled(Styled.H2)`
@media screen and (min-width: 1000px) {
 display:none;
}
`
export const StyledContainerWrapper = styled(Styled.ContainerWrapper)`
@media screen and (max-width: 999px) {
    flex-direction:column-reverse;
}
`
export const ButtonWrapper = styled.div`
@media screen and (min-width: 450px)and (max-width: 999px) {
    display: flex;
    justify-content:center;
    align-items: center;
}
`